export default "<p>dotnet works!</p>\n"